module.exports = __webpack_public_path__ + "static/media/ShortText.88021c3a.svg";